// extracted by mini-css-extract-plugin
export default {"modal":"LoadingModal_modal__4FtB9","wrapper":"LoadingModal_wrapper__UPPYD","text":"LoadingModal_text__l7muP"};